import React, { useEffect, useState } from "react";
import * as zh from "plotly.js/lib/locales/zh-cn";
import Plot from "react-plotly.js";
import { useSelector } from "react-redux";

const ChartPlot = ({
  date,
  data,
  color,
  title,
  cips,
  i18n,
  label,
  threshold,
}) => {
  const { filtrate_suspended, flow, pressure, temperature, feed_suspended } =
    useSelector((state) => state);
  const [plotData, setPlotData] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [minY, setMinY] = useState(null);
  const [maxY, setMaxY] = useState(null);

  const unitSelector = (name) => {
    name = String(name);
    try {
      if (name) {
        if (name.toLowerCase().includes("Flow".toLowerCase())) {
          return flow;
        } else if (
          name.toLowerCase().includes("Pressure".toLowerCase()) ||
          name.toLowerCase().includes("tmp".toLowerCase())
        ) {
          return pressure;
        } else if (name.toLowerCase().includes("filtrate".toLowerCase())) {
          return filtrate_suspended;
        } else if (
          name.toLowerCase().includes("temperature".toLowerCase()) ||
          name.toLowerCase().includes("Temp".toLowerCase())
        ) {
          return `&deg;${temperature}`;
        } else if (name.toLowerCase().includes("feed".toLowerCase())) {
          return feed_suspended;
        }
      }
    } catch (err) {}
    return "";
  };

  const unit = unitSelector(label);
  const setNormalizePermeate = () => {
    const x = [];
    const y = [];
    for (const key in date) {
      x.push(date[key]);
      y.push(data[key]);
    }

    rowData.push({
      x,
      y,
      mode: "markers",
      type: "scattergl",
      text: "",
      marker: { color: color, size: 2 },
      hoverinfo: "x+y",
    });

    const numericValues = y
      .map((value) => parseFloat(value))
      .filter((value) => !isNaN(value));
    setMaxY(Math.max(...numericValues));
    setMinY(Math.min(...numericValues));
    setRowData(rowData);
    setPlotData(rowData);
  };

  const layout = {
    yaxis: {
      ticks: "outside",
      linecolor: "#ccc",
      linewidth: 2,
      mirror: true,
      title: unit,
      showlegend: true,
    },
    xaxis: {
      type: "date",
      tickformat: "%d/%m/%Y %H:%M:%S",
      ticks: "outside",
      linecolor: "#ccc",
      linewidth: 2,
      mirror: true,
    },

    width: Math.round((90 / 100) * window.innerWidth),
    height: 120,
    margin: {
      b: 30,
      t: 30,
    },
    showlegend: false,
    font: {
      size: 10, // Set the font size
      color: "--color-primary-black", // Set the font color
    },
  };

  useEffect(() => {
    setNormalizePermeate();
  }, [data]);

  useEffect(() => {
    const verticalTraces = [...rowData];
    if (cips) {
      cips.map((item) => {
        const verticalLineTrace = {
          x: [item.cleaning_start_time, item.cleaning_start_time],
          y: [minY, maxY],
          mode: "lines",
          hoverinfo: "x",
          line: {
            color: item.is_tool_identified ? "black" : "red",
            dash: "line",
            width: 1,
          },
        };
        verticalTraces.push(verticalLineTrace);
      });
    }

    if (threshold) {
      // Create threshold line with same y-value for all x-axis dates
      // This enables continuous hover along the entire line
      // As we are getting date as object in cleaning advisor charts converting it to array
      const allDates = Object.values(date);
      const allYValues = allDates.map(() => threshold[0]);
      const horizontalLineTrace = {
        x: allDates,
        y: allYValues,
        mode: "lines",
        hoverinfo: "x+y",
        line: {
          color: "red",
          dash: "dot",
          width: 1,
        },
      };
      verticalTraces.push(horizontalLineTrace);
    }

    setPlotData([...verticalTraces]);
  }, [cips, minY, maxY, threshold]);

  return (
    <Plot
      data={plotData}
      layout={{
        ...layout,
        title: {
          text: title + (unit ? " (" + unit + ")" : ""),
          font: {
            color: color,
            size: 12,
          },
        },
      }}
      config={{
        locales: { [i18n.language]: i18n.language === "zh" ? zh : "" },
        locale: i18n.language,
        responsive: true,
        toImageButtonOptions: {
          format: "png",
          filename: title,
          height: 480,
          width: 640,
        },
      }}
    ></Plot>
  );
};

export default ChartPlot;
